import { QRCodeCanvas } from "qrcode.react";
import { horarioDeHoy } from "@/lib/escposHelper";
import { seqDeFolio } from "./constants";
import { fmtDateTime } from "@/lib/datetime";

// Sprint 9.0 (Fase 3) — Comprobantes térmicos a dos vías (cliente + talón operativo). Presentacional puro.
export function ValetTickets({ recibo, sucursal, leyenda, horario, tarifaTexto }) {
  const seq = seqDeFolio(recibo.folio_impreso);
  const fecha = recibo.fecha_entrada ? fmtDateTime(recibo.fecha_entrada, { dateStyle: "short", timeStyle: "short" }) : "";
  const horarioHoy = horarioDeHoy(horario); // Sprint 20.4 — solo el horario del día actual
  const CampoOp = ({ label, value }) => (
    <div className="tr-field">
      {value ? <span><b>{label}:</b> {value}</span> : <span><b>{label}:</b> <span className="tr-fill" /></span>}
    </div>
  );
  return (
    <div className="thermal-receipt tr-w80" data-testid="valet-thermal">
      {/* Ticket 1 — Comprobante Cliente */}
      <div className="tr-center tr-brand">{sucursal?.nombre || "Valet Parking"}</div>
      {horarioHoy && String(horarioHoy).trim() ? <div className="tr-center tr-sm" data-testid="valet-thermal-horario">Horario hoy: {horarioHoy}</div> : null}
      <div className="tr-center tr-sm">COMPROBANTE DE RESGUARDO</div>
      <div className="tr-center tr-sm">TURNO #</div>
      <div className="tr-huge">{seq}</div>
      <div className="tr-center tr-sm">Ingreso: {fecha}</div>
      {tarifaTexto ? <div className="tr-center tr-bold" data-testid="valet-thermal-tarifa">Tarifa: {tarifaTexto}</div> : null}
      <div className="tr-qr"><QRCodeCanvas value={`${window.location.origin}/t/${recibo.folio_impreso}`} size={120} level="M" /></div>
      <div className="tr-center tr-sm">{recibo.folio_impreso}</div>
      {/* Sprint 20.4 — Cláusulas: ÚNICAMENTE la leyenda corta configurada (sin bloque legal hardcoded). */}
      {leyenda && String(leyenda).trim() ? <div className="tr-terms" data-testid="valet-thermal-leyenda">{leyenda}</div> : null}

      <div className="tr-cut" />

      {/* Ticket 2 — Talón Operativo / Para Llaves */}
      <div className="tr-center tr-sm">TALÓN OPERATIVO · TURNO #</div>
      <div className="tr-huge">{seq}</div>
      <div className="tr-center tr-sm">{recibo.folio_impreso}</div>
      <div style={{ marginTop: "2mm" }}>
        <CampoOp label="NOMBRE" value={recibo.nombre_cliente} />
        <CampoOp label="MARCA/MOD" value={recibo.marca_modelo} />
        <CampoOp label="COLOR" value={recibo.color} />
        <CampoOp label="PLACAS" value={recibo.placa} />
        <CampoOp label="OBJETOS" value={recibo.objetos_valor} />
      </div>
      <div className="tr-box">UBICACIÓN: [ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ]</div>
    </div>
  );
}

export default ValetTickets;
